// Lib
import React, { useMemo } from 'react';

// Components
import AddressTitle from '../../Labels/AddressTitle/AddressTitle';

// Utils
import {
  getFullName,
  getCompany,
  getAddressType,
} from '../../../../utils/address';

// Styles
import { useStyles } from './AddressCardHeaderStyles';

const AddressCardHeader = ({ address, isListView, isAddressBookPage }) => {
  const fullName = useMemo(() => getFullName(address), [address]);
  const company = useMemo(() => getCompany(address), [address]);
  const addressType = useMemo(() => getAddressType(address), [address]);

  const { classes } = useStyles({ isListView, isAddressBookPage });

  return (
    <>
      {fullName && (
        <AddressTitle
          className={classes.fullName}
          title={fullName}
          data-testid="address-card-full-name"
        />
      )}
      {company && (
        <AddressTitle
          className={classes.company}
          title={company}
          data-testid="address-card-company"
        />
      )}
      {addressType && (
        <AddressTitle
          className={classes.addressType}
          title={<>&ldquo;{addressType}&rdquo;</>}
          data-testid="address-card-address-type"
        />
      )}
    </>
  );
};

export default AddressCardHeader;
